export default {
  async loadStoplightConcernOptions (context) {
    const { options } = await this.$feathers.service('forms/select-options').get('63d4869fe3c9882700f4675d')
    const arr = options.filter(({ disabled }) => !disabled).map(({ text, value }) => { return { text, value } }).map(({ text }) => text)
    context.commit('setStoplightConcernOptions', arr)
    return arr
  }
}
